import {DataContentWrapper} from '@hconnect/common/containers'
import {CardBox, CardLinkWrapper} from '@hconnect/uikit/src/lib2'
import {getPlantName, useUpmPlantsContext} from '@hconnect/upm'
import {Typography, Box, SxProps, Theme} from '@mui/material'
import {AREA_TIME_RANGE_PARAM} from '@widgets/area-dashboard'
import {PlantStatusDailyKpis} from '@widgets/kpis'
import {useTranslation} from 'react-i18next'
import {Link} from 'react-router'

import {FEATURE_NAMESPACE} from '../consts'
import {useOptimizationSpecialistKpis, useOptimizationSpecialistPlantTimeRange} from '../hooks'

type AreaOptimizationSpecialistCardContainerProps = {
  plantId: string
  plantLink: string
  cardBoxSx?: SxProps<Theme>
  kpiGridItemXs?: number
}

const cardBoxPx = {xs: 2, md: 3}

export const AreaOptimizationSpecialistCardContainer = ({
  plantId,
  plantLink,
  cardBoxSx,
  kpiGridItemXs
}: AreaOptimizationSpecialistCardContainerProps) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const {
    from,
    to,
    hasShifts,
    isLoading: isTimeRangeLoading
  } = useOptimizationSpecialistPlantTimeRange({
    defaultTimeRange: 'pastShift',
    key: AREA_TIME_RANGE_PARAM,
    plantId: plantId
  })

  const upmPlants = useUpmPlantsContext()

  const {
    data = [],
    isLoading: isKpiDataLoading,
    isError,
    isRefetching,
    refetch
  } = useOptimizationSpecialistKpis({
    plantId,
    from: from,
    to: to
  })

  return (
    <CardLinkWrapper<typeof Link> component={Link} to={plantLink}>
      <CardBox
        sx={{...cardBoxSx, px: 0, pl: cardBoxPx}}
        data-test-id={`plant-status-kpis-card-${plantId}`}
      >
        <Typography variant="h3" mb={2}>
          {getPlantName(upmPlants, plantId)}
        </Typography>
        <DataContentWrapper
          showLoader={isTimeRangeLoading || isKpiDataLoading}
          isError={isError}
          isRefetching={isRefetching}
          retryFunction={() => void refetch()}
          noDataSettings={{
            ...(!hasShifts && {
              noDataMessage: t('areaDashboard.shiftsNotEntered')
            })
          }}
          data={data}
          progressSx={{color: 'primary.main'}}
        >
          <Box sx={{maxHeight: {md: 250}, overflowY: 'auto', pr: cardBoxPx}}>
            {data && (
              <PlantStatusDailyKpis kpiItems={data} gridItemXs={kpiGridItemXs} kpiSize="S" />
            )}
          </Box>
        </DataContentWrapper>
      </CardBox>
    </CardLinkWrapper>
  )
}
